document.addEventListener("DOMContentLoaded", function() {
    CheckStatus();
});

function SetHeight(){
    var WindowWidth = window.innerWidth;

    var Form = document.getElementById("Form");

    //Only size the Form Container Block that holds the form, not the first container on the page
    var ContainerBlock = Form ? Form.closest('.FormContainerBlock') : null;
    //console.log(WindowWidth)
    if(ContainerBlock){

        if(WindowWidth > 767){

            var PageWidget = Form.offsetHeight;

            //-80 for padding + 100 for negative margin
            PageWidget = PageWidget - 100;

            ContainerBlock.style.minHeight = PageWidget + "px";

        }
        else{
            ContainerBlock.style.minHeight = 100 + "%";
        }
    }

}

function delay() {
    setTimeout(function() {
        CheckStatus();
    }, 200);
}

var Form = document.getElementById("Form");
if(Form){
    new ResizeObserver(() => delay()).observe(Form);
}

function CheckStatus(){

    if(document.readyState != "interactive"){
        SetHeight();
    } else {
        delay();
    }

} 